import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getEmailTemplateList = async (): Promise<string[]> => {
  const response = await queryExecute({
    query: graphql(`
      query GetEmailTemplateList {
        getEmailTemplateList
      }
    `),
    fetchPolicy: 'no-cache',
  });

  return response.data.getEmailTemplateList;
};
